import { useAviaryTheme } from "@fullscript/aviary-web";

import { useKeyCombo } from "@shared/hooks/useKeyCombo/useKeyCombo";
import { isProduction, isTest } from "@shared/utils/fullscriptEnv/fullscriptEnv";

import type { ThemeTypes } from "../AviaryThemeContext";

interface Props {
  controlledTheme: ThemeTypes;
  isEmerson: boolean;
}

/**
 * @deprecated DS4 component — DS5 support is in progress. Do not add new usages.
 */
const ThemeKeyboardShorcut = ({ controlledTheme, isEmerson }: Props) => {
  const { setTheme, currentTheme } = useAviaryTheme();
  // Dev-only shortcut to toggle between light and dark mode
  useKeyCombo({
    targetKeys: ["x"],
    withShift: true,
    disabled: isEmerson || isProduction() || isTest(),
    onPressed: () => {
      if (!controlledTheme) setTheme(currentTheme.theme === "dark" ? "light" : "dark");
    },
  });

  return null;
};

export { ThemeKeyboardShorcut };
